import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'vb-widgets-general-6',
  templateUrl: './6.component.html',
  styleUrls: ['./6.component.scss'],
})
export class VbGeneral6Component implements OnInit {
  constructor() {}
  ngOnInit() {}
}
